import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col ${
        isCenter ? "items-center text-center" : "md:flex-row md:items-end md:justify-between gap-4"
      } mb-8 md:mb-10`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 mb-3 uppercase">
            <span className="w-6 h-px bg-primary-400"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}